module.exports = __webpack_public_path__ + "img/KEN_agriExpansionGreenChg_2017.0c1486b0.jpg";